<div class="alert alert-{{type}} alert-elevate" [ngClass]="classes" role="alert" style="margin: 0px !important;">
	<div *ngIf="icon" class="alert-icon alert-icon-top">
		<i [ngClass]="icon"></i>
	</div>
	<div class="alert-text">
		<ng-content></ng-content>
	</div>
</div>
